import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import { useState, useEffect } from 'react';
import { GetCountries } from 'react-country-state-city';
import { taxIdOptions } from '../../utils/dropdownOptions';

export const CommercialInvoiceDetailsModal = ({ formik, show, handleClose, isReturnShipmentTab }) => {
    const [countries, setCountries] = useState([]);
    const values = isReturnShipmentTab ? formik.values.returnData : formik.values;

    useEffect(() => {
        const getCountries = async () => {
            const countries = await GetCountries();
            setCountries(countries);
        }

        getCountries();
    }, []);

    return (
        <Modal show={show} onHide={handleClose} backdrop='static'>
            <Modal.Header closeButton>Commercial Invoice information</Modal.Header>
            <Modal.Body>
                <fieldset>
                    <legend>International information</legend>
                    <Form.Group className='form-group'>
                        <Form.Label>Invoice number</Form.Label>
                        <Form.Control
                            name={isReturnShipmentTab ? 'returnData.invoiceNum' : 'invoiceNum'}
                            type='text'
                            {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.invoiceNum' : 'invoiceNum')}
                            disabled
                        />
                    </Form.Group>
                    <Form.Group className='form-group'>
                        <Form.Label>Consignee tax ID</Form.Label>
                        <InputGroup>
                            <Form.Select
                                name={isReturnShipmentTab ? 'returnData.consigneeTaxIdType' : 'consigneeTaxIdType'}
                                {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.consigneeTaxIdType' : 'consigneeTaxIdType')}
                            >
                                {
                                    taxIdOptions.map((i) => (
                                        <option key={i} value={i}>{i}</option>
                                    ))
                                }
                            </Form.Select>
                            <Form.Control
                                name={isReturnShipmentTab ? 'returnData.consigneeTaxId' : 'consigneeTaxId'}
                                type='text'
                                {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.consigneeTaxId' : 'consigneeTaxId')}
                            />
                        </InputGroup>
                    </Form.Group>
                </fieldset>
                <fieldset>
                    <legend>Sold to / importer (if different from consignee)</legend>
                    <Form.Check
                        type='checkbox'
                        name={isReturnShipmentTab ? 'returnData.sameAsConsignee' : 'sameAsConsignee'}
                        label='Same as consignee'
                        checked={values.sameAsConsignee}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.sameAsConsignee' : 'sameAsConsignee')}
                    />
                    <br />
                    {!values.sameAsConsignee && <>
                        <Form.Group className='form-group'>
                            <Form.Label>Tax ID</Form.Label>
                            <InputGroup>
                                <Form.Select
                                    name={isReturnShipmentTab ? 'returnData.soldToTaxIdType' : 'soldToTaxIdType'}
                                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.soldToTaxIdType' : 'soldToTaxIdType')}
                                >
                                    {
                                        taxIdOptions.map((i) => (
                                            <option key={i} value={i}>{i}</option>
                                        ))
                                    }
                                </Form.Select>
                                <Form.Control
                                    name={isReturnShipmentTab ? 'returnData.soldToTaxId' : 'soldToTaxId'}
                                    type='text'
                                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.soldToTaxId' : 'soldToTaxId')}
                                />
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className='form-group'>
                            <Form.Label>Country</Form.Label>
                            <Form.Select
                                name={isReturnShipmentTab ? 'returnData.soldToCountry' : 'soldToCountry'}
                                {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.soldToCountry' : 'soldToCountry')}
                            >
                                <option value=''>Select an option</option>
                                {
                                    countries.map((c) => (
                                        <option key={c.id} value={c.iso2}>{c.iso2} - {c.name}</option>
                                    ))
                                }
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className='form-group'>
                            <Form.Label>Company name</Form.Label>
                            <Form.Control
                                name={isReturnShipmentTab ? 'returnData.soldToCompanyName' : 'soldToCompanyName'}
                                type='text'
                                {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.soldToCompanyName' : 'soldToCompanyName')}
                            />
                        </Form.Group>
                        <Form.Group className='form-group'>
                            <Form.Label>Address 1</Form.Label>
                            <Form.Control
                                name={isReturnShipmentTab ? 'returnData.soldToAddress1' : 'soldToAddress1'}
                                type='text'
                                {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.soldToAddress1' : 'soldToAddress1')}
                            />
                        </Form.Group>
                        <Form.Group className='form-group'>
                            <Form.Label>Address 2</Form.Label>
                            <Form.Control
                                name={isReturnShipmentTab ? 'returnData.soldToAddress2' : 'soldToAddress2'}
                                type='text'
                                {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.soldToAddress2' : 'soldToAddress2')}
                            />
                        </Form.Group>
                        <Form.Group className='form-group'>
                            <Form.Label>Address 3</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    name={isReturnShipmentTab ? 'returnData.soldToAddress3' : 'soldToAddress3'}
                                    type='text'
                                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.soldToAddress3' : 'soldToAddress3')}
                                />
                                <InputGroup.Text>(Express only)</InputGroup.Text>
                            </InputGroup>
                        </Form.Group>
                        <Row className='form-group'>
                            <Form.Group as={Col}>
                                <Form.Label>Postal code</Form.Label>
                                <Form.Control
                                    name={isReturnShipmentTab ? 'returnData.soldToPostalCode' : 'soldToPostalCode'}
                                    type='text'
                                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.soldToPostalCode' : 'soldToPostalCode')}
                                />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <Form.Label>State/Province</Form.Label>
                                <Form.Control
                                    name={isReturnShipmentTab ? 'returnData.soldToState' : 'soldToState'}
                                    type='text'
                                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.soldToState' : 'soldToState')}
                                />
                            </Form.Group>
                        </Row>
                        <Form.Group className='form-group'>
                            <Form.Label>City</Form.Label>
                            <Form.Control
                                name={isReturnShipmentTab ? 'returnData.soldToCity' : 'soldToCity'}
                                type='text'
                                {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.soldToCity' : 'soldToCity')}
                            />

                        </Form.Group>
                    </>}
                </fieldset>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleClose} className='purple-btn'>Ok</Button>
            </Modal.Footer>
        </Modal>
    )
}
